import React from 'react';

const ContactDetails = () => {
    return (



        <table className="w-full text-sm dark ">
            <tbody>
                <tr >
                    <td className=" text-left py-2  font-medium text-gray-900 whitespace-nowrap ">
                        <span className='p-1 rounded bg-blue-300'>Email me: </span>
                    </td>
                    <td className=" text-right">
                        sshanto.cse@gmail.com
                    </td>
                </tr>
                <tr >
                    <td className=" text-left py-2  font-medium text-gray-900 whitespace-nowrap ">
                        <span className='p-1 rounded bg-blue-300'> Call/Whatsapp me: </span>
                    </td>
                    <td className=" text-right">
                        +8801516173249
                    </td>
                </tr>
                <tr >
                    <td className=" text-left  py-2 font-medium text-gray-900 whitespace-nowrap ">
                        <span className='p-1 rounded bg-blue-300'> Address:</span>
                    </td>
                    <td className=" text-right">
                        Dhaka, Bangladesh
                    </td>
                </tr>
                <tr >
                    <td className=" text-left  py-2 font-medium text-gray-900 whitespace-nowrap ">
                        <span className='p-1 rounded bg-blue-300'> Zip:</span>
                    </td>
                    <td className=" text-right">
                        1216
                    </td>
                </tr>
            </tbody>
        </table>


    );
};

export default ContactDetails;